import { render, staticRenderFns } from "./HerbIdeal.vue?vue&type=template&id=41286f4c&scoped=true"
import script from "./HerbIdeal.vue?vue&type=script&lang=js"
export * from "./HerbIdeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41286f4c",
  null
  
)

export default component.exports